import * as AppConstants from 'app/AppConstants';
import {hasLoadedStack, isStackLoading} from './stackSelectors';
import {
  fetchStackById,
  grantAccessToStack,
  requestAccess as requestAccessService,
  assignPowerUp as assignPowerUpService,
} from './stackService';

const PAGE_ACCESS_DENIED = 'PAGE_ACCESS_DENIED';

export const load = id => {
  return (dispatch, getState) => {
    const state = getState();
    if (hasLoadedStack(state, id) || isStackLoading(state, id)) return null;

    dispatch({
      type: AppConstants.STACK__LOAD_BY_ID_STARTED,
      payload: {
        id,
      },
    });

    fetchStackById(id).then(
      response => {
        dispatch({
          type: AppConstants.STACK__LOAD_BY_ID_FINISHED,
          payload: {
            id,
            stack: response,
          },
        });
      },
      err => {
        const response = err.response ? err.response.data : {};
        if (response.error === PAGE_ACCESS_DENIED) {
          dispatch({
            type: AppConstants.STACK__LOAD_BY_ID_ACCESS_DENIED,
            payload: {
              id,
              errorInfo: response.errorInfo,
            },
          });
        } else {
          dispatch({
            type: AppConstants.STACK__LOAD_BY_ID_FAILED,
            payload: {
              id,
            },
          });
        }
      }
    );
  };
};

export const grantAccessByStackId = (stackId, userIds, groupIds) => {
  return dispatch => {
    const success = () => {
      dispatch({
        type: AppConstants.STACK__GRANTED_ACCESS_TO_STACK,
        payload: {
          id: stackId,
          userIds,
          groupIds,
        },
      });
    };

    // jQuery rejects empty response bodys, even if they are 200
    return grantAccessToStack(stackId, userIds, groupIds).then(
      success,
      success
    );
  };
};

export const requestAccess = stackId => dispatch => {
  requestAccessService(stackId).then(() => {
    dispatch({
      type: AppConstants.STACK__ACCESS_REQUESTED,
      payload: {
        stackId,
      },
    });
  });
};

export const assignPowerUp = (stackId, userId) => dispatch => {
  dispatch({
    type: AppConstants.STACK__POWER_UP_ASSIGNED,
    payload: {
      stackId,
      userId,
    },
  });

  return assignPowerUpService({
    pageId: stackId,
    assignee: userId,
  });
};
